// import React from "react";
// import { createRoot, hydrateRoot } from "react-dom/client";
// import "./index.css";
// import App from "./App";
// import reportWebVitals from "./reportWebVitals";
// import { BrowserRouter } from "react-router-dom";


// const app = (
//     <BrowserRouter>
//       <App />
//     </BrowserRouter>
// );

// const rootEl = document.getElementById("root");
// const mode = rootEl?.dataset?.mode;

// if (rootEl && mode !== "php") {
//   if (rootEl.hasChildNodes()) {
//     hydrateRoot(rootEl, app);
//   } else {
//     createRoot(rootEl).render(app);
//   }
// }

// reportWebVitals();


import "./index.css";
import reportWebVitals from "./reportWebVitals";

const mode = window.__PAGE_MODE__ || "spa";

if (mode === "php") {
  import("./php_islands").then((m) => m.mountPhpIslands());
} else {
  const rootEl = document.getElementById("root");
  if (rootEl) import("./spa").then((m) => m.mountSpa(rootEl));
}

reportWebVitals();
